import { createReducer, updateDeepState } from '../handlers'
import types from './types'

const initialState = {
  open: false,
  moduleName: '',
  type: 'flow',
  subtype: '', // values: add or remove
  message: '',
  flow: {
    title: '',
    lastPopup: '',
    steps: [] // { component: change_plan|payment_add_method }
  },
  oldRequest: {}
}

/**
 * Display error
 * @param {Object} action
 * @param {Object<initialState>} action.error
 */
const display = (state, action) => {
  const { error, config } = action

  return updateDeepState(state, { ...error, open: true, oldRequest: config })
}

export default createReducer(initialState, {
  [types.display]: display,
  [types.clear]: () => updateDeepState(initialState),
})
